class About {
  constructor(element, options) {
    this._element = element;
    this._options = { ...options };
    this._cacheSelectors();
    this._init();
  }

  _cacheSelectors() {
    this._triggers = document.querySelectorAll('.js-more');
  }

  _init() {
    this._triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        const _this = e.currentTarget;

        const panelGroup = _this.parentElement; //.about__more
        const panel = _this.nextElementSibling;

        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
          panelGroup.classList.remove('is-active');
        } else {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
          panelGroup.classList.add('is-active');
        }
      });
    });
  }
}

export default About;
